module.exports = __webpack_public_path__ + "static/media/feat-olympic-hero.d297cd3d.jpg";